import {
  Tabs,
  Tab,
  Link,
  HorizontalScroll,
} from "../../../../../pages/Dashboard/components/styles";
import { connect } from "react-redux";
import { useMemo } from "react";
import { User } from "../../../../../types";

interface ComponentProps {
  active: string;
  user: User;
}

const Component = ({ active, user }: ComponentProps) => {

  const isExpert = useMemo((): boolean => {
    return !!user?.expert?.id;
  }, [user]);

  return (
    <HorizontalScroll>
      <Tabs>
        <Tab>
          <Link to="/profile/my-account" active={active === "profile"}>
            Perfil
          </Link>
        </Tab>
        <Tab>
          <Link to={`/profile/manage-subscriptions`} active={active === "manage-subscriptions"}>
            Administrar suscripciones
          </Link>
        </Tab>
        {isExpert && (
          <>
            <Tab>
              <Link
                to={`/profile/notifications`}
                active={active === "notifications"}
              >
                Notificaciones
              </Link>
            </Tab>
            <Tab>
              <Link
                to={`/profile/gateways`}
                active={active === "gateways"}
              >
                Pasarelas de pago
              </Link>
            </Tab>
            <Tab>
              <Link to={`/profile/analytics`} active={active === "analytics"}>
                Analytics
              </Link>
            </Tab>
          </>
        )}
      </Tabs>
    </HorizontalScroll>
  );
};

const state = ({ userStore }) => {
  const { data: user, states: userStates } = userStore.information;

  return {
    user,
    userStates,
  };
};

export default connect(state)(Component);
